import { render, staticRenderFns } from "./UkStep3.vue?vue&type=template&id=7c073896&scoped=true&lang=tr"
import script from "./UkStep3.vue?vue&type=script&lang=js"
export * from "./UkStep3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c073896",
  null
  
)

export default component.exports